export default class TransiVideo {
    constructor(){
        let me=this;
        this.$main=$(require("./transi-video.html"));
        this.$video=me.$main.find("video");
        $body.append(me.$main);
        //permet de débloquer le bazar
        this.timeout=null;
        this.isPlaying=false;
        this.$video[0].addEventListener('ended', function(e) {
            me.isPlaying=false;
            me.onEnded();
        });
        this.$video[0].addEventListener('error', function(e) {
            me.isPlaying=false;
            me.onEnded();
        });
        this.$video[0].addEventListener('play', function(e) {
            me.isPlaying=true;
        });
        this.onEnded=function(){
            console.log("fini not init");
            alert("fini not init");
        };

        //filtre les videos
        this._supportWebM=this.$video[0].canPlayType('video/webm; codecs="vp8, vorbis"');
        this._videos=LayoutVars.transitionVideos;
        this._videos=this._shuffle(this._videos);
        if(!this._supportWebM){
            let rx=new RegExp(/\.mp4$/);
            //uniquement des mp4 si pas de support webm
            this._videos = this._videos.filter(function(file){
                return rx.test(file)
            });
        }
        this._videoIndex=0;
        me.preloadNext();
    }

    /**
     * Shuffles array in place. ES6 version
     * @param {Array} a items An array containing the items.
     */
    _shuffle(a) {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }
    _nextVideo(){
        this._videoIndex++;
        if(this._videoIndex>=this._videos.length){
            this._videoIndex=0;
        }
        return this._videos[this._videoIndex];
    }

    clearTimer(){
        if(this.timeout){
            clearTimeout(this.timeout);
        }
    }

    /**
     * Précharge la prochaine video
     */
    preloadNext(){
        this.$video.attr("src",this._nextVideo());
    }

    /**
     *
     * @param {function} onComplete
     */
    play(){
        let me=this;
        me.isPlaying=true;
        me.$video[0].play();
        this.clearTimer();
        this.timeout=setTimeout(function(){
                me.clearTimer();
                me.isPlaying=false;
                me.onEnded();
        },1000*5);
    }


}


// WEBPACK FOOTER //
// ./project/_src/transition-videos/TransiVideo.js